import axiosInstance from "../config/API";
const API = "/staff_advance.php";

export const fetchStaffAdvanceApi = async (staff_id, from_date, to_date) => {
  const res = await axiosInstance.post(API, {
    action: "listAdvance",
    staff_id,
    from_date,
    to_date,
  });
  return res.data.body.advances;
};

export const addStaffAdvanceApi = async (data) => {
  const res = await axiosInstance.post(API, { action: "addAdvance", ...data });
  return res.data;
};

export const updateStaffAdvanceApi = async (data) => {
  const res = await axiosInstance.post(API, {
    action: "updateAdvance",
    ...data,
  });
  return res.data;
};

export const deleteStaffAdvanceApi = async (id) => {
  const res = await axiosInstance.post(API, { action: "deleteAdvance", id });
  return res.data;
};
